import { lazy } from 'react';

export const BlankAddLazy = lazy(() => import('./BlankAdd'));
